/*
 * UserProfile by karora on 21/03/17.
 */
import { SocialProfile } from './social-profile';

export class UserProfile {
  id: string;
  type: number;
  review: boolean;
  administer: boolean;
  social: SocialProfile;
  programme_rights: Map<number, string>;
}
